export default {
  taskRecord: {
    title: "Phần thưởng nhiệm vụ",
    loading: "Đang tải...",
    empty: "Không có phần thưởng",
    completed: "Nhiệm vụ đã hoàn thành",
    desc: "Hoàn thành nhiệm vụ để nhận thưởng",
    close: "Đóng",
    add: "Thêm",
    addEmail: "Thêm Email",
    addPhoneNumber: "Thêm Số Điện Thoại",
    addBirthday: "Thêm Ngày Sinh",
    downloadNow: "Tải Ngay",
    phone: "Số điện thoại",
    email: "Địa chỉ email",
    bank: "Thẻ ngân hàng",
    birthday: "Ngày sinh",
    download: "Tải xuống",
    downloadApp: "Tải APP",
    registerBonus: "Thưởng Đăng Ký",
    firstInviteBonus: "Thưởng Mời Bạn Đầu Tiên",
    invite: "Mời",
    inviteNow: "Mời Bạn Bè",
    go: "Đi",
    receive: "Nhận",
    received: "Đã nhận",
    task: "Nhiệm vụ",
	claimRewards: 'Nhận phần thưởng',
    receiveSuccess: 'Đã nhận phần thưởng thành công',
    receiveFail: 'Nhận phần thưởng thất bại'
  }
};
